interface Props {
  id: number
  title: string
}

export const Calligraphy: React.FC<Props> = ({ id, title }) => {
  return (
    <div className="relative flex-1 sm:flex-none sm:px-5 pr-5 sm:pb-[10px] sm:align-top">
      <img
        src={`${process.env.IMG_SERVER}/summary/${id}_cover_300.jpg`}
        alt={title}
        className="w-full sm:w-[220px] align-middle border-none shadow-flier"
      />
    </div>
  )
}
